import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GridNavService } from './grid.nav.service';
import { GridNavSharedComponent } from './grid.nav.component';
import { BrowserService } from './../../../shared/service/browser/browser.service';

@NgModule({
    declarations: [
        GridNavSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        GridNavSharedComponent
    ],
    providers: [
        BrowserService,
        GridNavService
    ]
})

export class GridNavSharedModule {}
